import theme from 'assets/theme';
import { subYears, addYears } from 'date-fns';

export const NAVBAR_HEIGHT = '90px';
export const SIDEBAR_WIDTH = '200px';
export const NEGATIVE_NUMBER_COLOR = theme.palette.error.main;
// Row background for a "subtotal" line item — used consistently across the project table
// (ProjectTable.tsx), the payapp Step 2 table (PayappTable.tsx), and the payapp Step 3/4
// merge/preview grid (DrawLineItemsTable.tsx).
export const SUBTOTAL_ROW_BACKGROUND_COLOR = '#DAF3FF';
export const minAllowedDate = subYears(new Date(), 100);
export const maxAllowedDate = addYears(new Date(), 50);
export const ONE_DAY_MS = 24 * 60 * 60 * 1000;
export const PAGES_STRING_REGEX = /^$|^([1-9]\d*(-[1-9]\d*)?)(,[1-9]\d*(-[1-9]\d*)?)*$/;
export const REDUCTION_DIFFERENCE_THRESHOLD = 0.01;
export const UNDEFINED_CHANGE_ORDER_DIVISION_CODE = '21.00';
